<div class="bottom-header-wrapper">
    <div class="bottom-header-left">bottom-header left!</div>
    <div class="bottom-header-center">
        <nb-menu [items]="menuItems" class="menu-items"></nb-menu>
    </div>
    <div class="bottom-header-right">bottom-header right!</div>
</div>
